export default {
  black: "#000000",
  white: "#ffffff",
  brand: "#fee81f",
  brandDark: "#00263F",
  primary: "#0080E2",
  primaryHover: "#0067B5",
  secondary: "#65777d", // Is "#727A7D" in the mockups, needed to be a tad bit darker for contrast issues,
  secondaryHover: "#39414D",
  error: "#F79724",
  errorHover: "#F79724",
};
